package org.hs_soft.runmynesto.domain.usecase.product

import org.hs_soft.runmynesto.domain.repository.network_datasource.home.DeleteCacheRepository


class DeleteCacheUseCase(
    private val repository: DeleteCacheRepository
) {
    suspend operator fun invoke() {
        return repository.deleteProductCache()
    }


}